import React from 'react';
import { browserTimeZone, describeTimeZone, getTimeZoneName } from '@repo/lib';
import Tooltip from '@dashboard/components/Tooltip';
import { formatDateTime } from '@dashboard/lib/format-date';
import { cn } from '@dashboard/lib/utils';

type DateInput = Date | string | number;

interface TimeZoneLabelProps {
  date?: DateInput;
  timeZone?: string;
  className?: string;
}

export const TimeZoneLabel = ({
  date = new Date(),
  timeZone = browserTimeZone(),
  className,
}: TimeZoneLabelProps) => (
  <Tooltip
    label={describeTimeZone(date, { timeZone })}
    delayDuration={0}
    triggerClassName={cn('cursor-help', className)}
  >
    {getTimeZoneName(date, { timeZone })}
  </Tooltip>
);

export const DateTimeWithZone = ({
  date,
  timeZone = browserTimeZone(),
}: {
  date: DateInput;
  timeZone?: string;
}) => (
  <>
    {formatDateTime(date, { timeZone })} <TimeZoneLabel date={date} timeZone={timeZone} />
  </>
);
